export const OPCIONES = [{
    body: {
        paddingTop: 25,
        paddingBottom: 60,
        paddingLeft: 20,
        paddingRight: 20,
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    row: {
        flexDirection: 'row'
    },
    borde: {
        border: 0.6,
        borderColor: "#000",
        borderRadius: 2,
        paddingBottom: 2,
    },
    borde2: {
        border: 0.8,
        marginLeft: 2,
        marginRight: 2,
        borderColor: "#000",
    },
    borde3: {
        borderTop: 0.8,
        marginLeft: -1,
        borderColor: "#000",
    },
    borde4: {
        border: 0.8,
        marginLeft: 40,
        marginRight: 40,
        borderColor: "#000",
    },
    borde5: {
        border: 0.8,
        marginLeft: 40,
        marginRight: 40,
        borderColor: "#cccccc",
    },
    /* ---------------------- */

    col1: {
        paddingLeft: 2,
        width: 221,
        borderRight: 0.8,
    },
        col1_1: {
            paddingLeft: 2,
            width: 70,
        },
        col1_2: {
            paddingLeft: 2,
            width: 150,
            borderRight: 0.8,
        },
    col2: {
        paddingLeft: 2,
        width: 161,
        borderRight: 0.8,
    },
        col2_1: {
            paddingLeft: 2,
            width: 85,
        },
        col2_2: {
            paddingLeft: 2,
            width: 76,
            borderRight: 0.8,
        },
        col2_3: {
            paddingLeft: 2,
            width: 382,
            borderRight: 0.8,
        },
    col3: {
        paddingLeft: 2,
        width: 122,
        borderRight: 0.8,
    },
        col3_1: {
            paddingLeft: 2,
            width: 30.2,
            borderRight: 0.8,
        },
        col3_2: {
            paddingLeft: 2,
            width: 62,
            borderRight: 0.8,
        },
            col3_2_1: {
                paddingLeft: 2,
                width: 31,
                borderRight: 0.8,
            },
        col3_3: {
            paddingLeft: 2,
            width: 92,
        },
        col3_4: {
            paddingLeft: 2,
            width: 28,
            borderRight: 0.8,
        },
        col3_5: {
            paddingLeft: 2,
            width: 40,
            borderRight: 0.8,
        },
        col3_6: {
            paddingLeft: 2,
            width: 58,
            borderRight: 0.8,
        },
        col3_7: {
            paddingLeft: 2,
            width: 33,
        },
        col3_8: {
            paddingLeft: 2,
            width: 30.5,
            borderRight: 0.8,   
        },
        col3_9: {
            paddingLeft: 2,
            width: 40.3,
            borderRight: 0.8,   
        },
        col3_10: {
            paddingLeft: 2,
            width: 63.2,
        },
    col4: {
        paddingLeft: 2,
        width: 62,
    },
    col5: {
        paddingLeft: 2,
        width: 382,
    },
    col6: {
        paddingLeft: 2,
        width: 120,
        borderRight: 0.8,
        borderLeft: 0.8,
    },
    col7: {
        paddingLeft: 2,
        width: 63,
    },
    col8: {
        paddingLeft: 2,
        width: 169,
        borderRight: 0.8,
    },
    col9: {
        paddingLeft: 2,
        width: 129,
    },
        col9_1: {
            paddingLeft: 2,
            width: 60,
        },
        col9_2: {
            paddingLeft: 2,
            width: 69,
        },
        col9_3: {
            paddingLeft: 2,
            width: 84,
        },
        col9_4: {
            paddingLeft: 2,
            width: 481,
        },
        col9_5: {
            paddingLeft: 2,
            width: 120,
        },
    col10: {
        paddingLeft: 2,
        width: 60,
    },
    col11: {
        paddingLeft: 2,
        width: 30,
    },
    col12: {
        paddingLeft: 2,
        width: 431,
        borderRight: 0.8,
    },
    col13: {
        paddingLeft: 2,
        width: 133,
    },
    col14: {
        paddingLeft: 2,
        width: 70,
    },
        col14_1: {
            paddingLeft: 2,
            width: 40,
        },
        col14_2: {
            paddingLeft: 2,
            width: 100,
        },
    col15: {
        paddingLeft: 2,
        width: 60,
    },

    col16_1: {
        paddingLeft: 2,
        width: 70,
        borderRight: 0.8,
        borderColor: "#cccccc",
    },
    col16_2: {
        paddingLeft: 2,
        width: 232,
        borderRight: 0.8,
        borderColor: "#cccccc",
    },
    col16_3: {
        paddingLeft: 2,
        width: 50,
        borderRight: 0.8,
        borderColor: "#cccccc",
    },
    col16_4: {
        paddingLeft: 2,
        width: 120,
        borderRight: 0.8,
        borderColor: "#cccccc",
    },
    /* ---------------------- */

    text1: {
        paddingTop: 5,
        fontSize: 8,
        textAlign: 'center',
    },
    text2: {
        paddingTop: 5,
        fontSize: 10,
        textAlign: 'center',
    },
    text3: {
        paddingTop: 5,
        fontSize: 8,
        textAlign: 'left',
    },
    text1White: {
        fontSize: 6,
        textAlign: 'center',
        color: "#FFF"
    },
    text4: {
        paddingTop: 5,
        fontSize: 6,
        textAlign: 'center',
    },
        text4_1: {
            paddingTop: 3,
            fontSize: 5,
            textAlign: 'center',
        },
        text4_2: {
            paddingTop: 3,
            fontSize: 8,
            textAlign: 'center',
        },
        text4_2_l: {
            paddingTop: 3,
            fontSize: 8,
            textAlign: 'left',
        },
    text5: {
        fontSize: 6,
        textAlign: 'center',
        color: "#aeaeae"
    },
    text5_1: {
        fontSize: 6,
        textAlign: 'center',
        color: "#000"
    },
    text6: {
        paddingTop: 2,
        fontSize: 9,
        textAlign: 'left',
    },
    text7: {
        fontSize: 10,
        textAlign: 'left',
    },
    text8: {
        fontSize: 7,
        textAlign: 'center',
    },
        text8_1: {
            fontSize: 6,
        },
        text8_2: {
            fontSize: 5,
        },
        text8_3: {
            fontSize: 4,
            textAlign: 'center',
        },
    text9: {
        fontSize: 14,
        textAlign: 'center',
    },
    /* ---------------------- */
    fondo: {
        backgroundColor: "#aeaeae",
    },

    fondo2: {
        backgroundColor: "#919191",
    },
    fondo3: {
        backgroundColor: "#dfdfdf",
    },
    
    logoText: {
        border: 0.8,
        marginLeft: 2,
        marginRight: 2,
        backgroundColor: "#aeaeae",
    },
    logo: {
        marginTop: 3,
        marginLeft: 242,
        height: 70,
        width:70,
        padding:0,
    },
}];


// WEBPACK FOOTER //
// ./src/components/Reportes/Styles/StylesNotasCert.jsx